export interface ModuleConfigItem {
  id: string;
  disabled: boolean;
  visible: boolean;
  anchor?: string; // Anchor ID for navigation to the module section
}

export const moduleConfig: ModuleConfigItem[] = [
  { id: 'cover', disabled: false, visible: true, anchor: 'module-cover' },
  { id: 'agentInfo', disabled: false, visible: true, anchor: 'module-agentInfo' },
  { id: 'assetProfile', disabled: true, visible: false, anchor: 'module-assetProfile' },
  { id: 'valuation', disabled: false, visible: true, anchor: 'module-valuation' },
  { id: 'marketValueGraph', disabled: false, visible: true, anchor: 'module-marketValueGraph' },
  { id: 'comparativeGraph', disabled: false, visible: true, anchor: 'module-comparativeGraph' },
  { id: 'financialData', disabled: false, visible: true, anchor: 'module-financialData' },
  { id: 'offerDemand', disabled: false, visible: true, anchor: 'module-offerDemand' },
  { id: 'zonePopulation', disabled: false, visible: true, anchor: 'module-zonePopulation' },
  { id: 'zone', disabled: false, visible: true, anchor: 'module-zone' },
  { id: 'comparables', disabled: false, visible: true, anchor: 'module-comparables' },
  { id: 'glossary', disabled: false, visible: false, anchor: 'module-glossary' },
  { id: 'terms', disabled: false, visible: false, anchor: 'module-terms' },
  { id: 'backCover', disabled: false, visible: false, anchor: 'module-backCover' },
  
  // EJEMPLOS DE CONFIGURACIÓN:
  // Para ocultar completamente un módulo del panel (pero que siga visible en el informe):
  // { id: 'glossary', disabled: false, visible: false },
  
  // Para hacer un módulo obligatorio (no se puede ocultar):
  // { id: 'cover', disabled: true, visible: true },
  
  // Para ocultar completamente un módulo (no aparece en panel y siempre visible):
  // { id: 'backCover', disabled: true, visible: false },
];

// Configuración por defecto para todos los módulos
export const defaultModuleVisibility: Record<string, boolean> = {
  cover: true,
  agentInfo: true,
  assetProfile: true,
  valuation: true,
  marketValueGraph: true,
  comparativeGraph: true,
  financialData: true,
  offerDemand: true,
  zonePopulation: true,
  zone: true,
  comparables: true,
  glossary: true,
  terms: true,
  backCover: true,
}; 